import api from './axiosInstance'

export default {
    addMarginalCost(payload) {
        return api.post('marginalCostOfReplacedEnergyRecords', payload);
    },
    updateMarginalCost(id, payload) {
        return api.put('marginalCostOfReplacedEnergyRecords/' + id, payload);
    },
    getAllMarginalCosts() {
        return api.get('marginalCostOfReplacedEnergyRecords');
    },
    getMarginalCost(id) {
        return api.get('marginalCostOfReplacedEnergyRecords/'+id);
    },
}